var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.params.node.group)?_c('v-flag',{attrs:{"countryCode":_vm.countryCode}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.getAriaText(_vm.params)))]),_vm._t("default",[_vm._v(_vm._s(_vm.countryLabel))])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }